import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a851d19bedae70014ea6586_1787322880430_7b0e44fc/ibnusyam/src/app/not-found.tsx");
